var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.5L9.8.7c.4-.4 1-.4 1.4 0l.1.1c.4.4.4 1 0 1.4L7.5 6l3.7 3.7c.4.4.4 1 0 1.4l-.1.1c-.4.4-1 .4-1.4 0L6 7.5l-3.7 3.7c-.4.4-1 .4-1.4 0l-.1-.1c-.4-.4-.4-1 0-1.4L4.5 6 .7 2.2C.3 1.8.3 1.2.7.8L.8.7c.4-.4 1-.4 1.4 0L6 4.5z"
  })));
}
export default SvgCloseIcon;